export default {"src":"/_next/static/media/tierUpgrade.6d618260.svg","height":650,"width":1059,"blurWidth":0,"blurHeight":0};